/**
 * 商品品名管理
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/3/8      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


import React from "react"
import Lang from "@components/Lang/Lang";
import {Tabs, Drawer, Spin, message, Input, Button,Carousel,Empty,Pagination,Image,Badge } from 'antd'
import './index.less'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import { toFixedWithCommas} from "@utils/number-util";
import LazyLoad from 'react-lazyload';
import dayjs from 'dayjs';
import Locale from '@/utils/locale'
let locale = Locale.current();
const config = require("../../../../config/config");
const { Search } = Input;

class SkuNameMgr extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            model:'',
            list:[],
            type:'0',//0:待完善 1：已完善
            keyword:'',
            visible:false,
            attrModel:{},
            attrLoading:false,

            //放大图
            imgCurrent:0,
            imgVisible:false,
            imgList:[],

            //分页
            pageIndex:1,
            pageSize:200,
            total:0
        }
    }

    /**
     * 获取数据
     */
    getData(pageIndex,pageSize) {
        const _this = this;
        this.setState({
            visible:false,
            attrModel:{},
            loading: true,
            list:[],
            total:0,
        }, () => {
            var postData = {
                type:this.state.type,
                pagingQuery: {
                    pageIndex: pageIndex||this.state.pageIndex,
                    pageSize: pageSize||this.state.pageSize
                },
            };
            if(this.state.keyword){
                postData.keyword = $.trim(this.state.keyword);
            }
            $.ajax({
                url: "/service/mg/goods/query-list",
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(postData),
                success: (res) => {
                    let data = {
                        loading: false,
                        model:{}
                    };
                    if (res.success && res.valid) {
                        res.models.map((item)=>{
                            if(!item.operateNameList||item.operateNameList.length==0){
                                item.operateNameList = [{lang:'ru',operateName:''}];
                            }
                            //是否已保存
                            if(_this.state.type=='0'){
                                item.isSave = false;
                            }else{
                                item.isSave = true;
                            }
                            item.isSubmitLoading = false;
                            return item;
                        })
                        data = Object.assign(data, {
                            model:res.model||'',
                            list: res.models || [],
                        });
                        //分页
                        if (res.paging) {
                            data = Object.assign(data, {
                                pageIndex: res.paging.pageNum,
                                pageSize: res.paging.pageSize,
                                total: res.paging.total,
                            });
                        }
                    }
                    this.setState(data);
                },
                error: () => {
                    let data = {
                        loading: false,
                    };
                    this.setState(data);
                },
            });
        })
    }

    /**
     * 切换tab
     * @param key String(0:待完善 1：已完善)
     **/
    tabsOnChange(key) {
        this.setState({
            type: key,
            keyword:'',
        },()=>{
            this.getData(1,200);
        })
    }

    /**
     * 保存
     **/
    save(index){
        let newList = [...this.state.list];
        newList[index].isSubmitLoading = true;
        this.setState({
            visible:false,
            list:[...newList]
        },()=>{
            const item  = newList[index];
            const newOperateNameList = item.operateNameList.map(item => {
                if (item.lang === 'ru') {
                    return { ...item, operateName:  $(this.refs[`input${index}`]).find('textArea').val() };
                }
                return item;
            });

            const postData = {
                skuId:item.skuId,
                spuId:item.spuId,
                operateNameList:newOperateNameList
            }
            let flag = true;
            for(var i=0;i<postData.operateNameList.length;i++){
                if(postData.operateNameList[i].lang=='ru'&&!$.trim(postData.operateNameList[i].operateName)){
                    flag = false;
                }
            }
            if(!flag){
                newList[index].isSubmitLoading = false;
                this.setState({
                    list:[...newList]
                },()=>{
                    message.info(Lang({id: 'QingShuRuShangPinPinMin', default: '请输入商品品名'}))
                });
                return false;
            }

            $.ajax({
                url: "/service/mg/goods/save-operate-name",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify(postData),
                success:(res)=>{
                    newList[index].isSubmitLoading = false;
                    if(res.success&&res.valid){
                        newList[index].isSave = true;
                    }
                    this.setState({
                        list:[...newList]
                    },()=>{
                        if(res.success&&res.valid){
                            message.success({
                                content:__getServerLanguage('BaoCunChengGong')
                            })
                        }else{
                            message.info({
                                content:res.message||__getServerLanguage('WangLuoGuZhangHuoZheXiTon')
                            })
                        }

                    })
                },error:()=>{

                }
            });
        })

    }

    /**
     * 编辑
     * @param index
     */
    edit(index){
        this.setState({
            list:this.state.list.map((item,i)=>{
                if(index===i){
                    item.isSave = false;
                }
                return item;
            })
        })
    }

    /**
     * 打开商品属性
     **/
    changeVisible(visible,item){
        if(item&&visible){
            if(
                (Object.keys(this.state.attrModel).length==0)||
                (
                    this.state.attrModel.skuId!=item.skuId||
                    this.state.attrModel.spuId!=item.spuId
                )
            ){
                this.setState({
                    attrLoading:true,
                    visible:visible
                },()=>{
                    $.ajax({
                        url: "/service/mg/goods/query-goods-attribute",
                        type:'post',
                        dataType: "json",
                        contentType: 'application/json',
                        data:JSON.stringify({
                            skuId:item.skuId,
                            spuId:item.spuId
                        }),
                        success:(res)=>{
                            let data = {
                                loading: false,
                            };
                            if (res.success && res.valid) {
                                data = Object.assign(data, {
                                    attrLoading:false,
                                    attrModel:Object.assign(res.model||{},{
                                        videoUrl:item.videoUrl,
                                        hasVideo:item.hasVideo
                                    })
                                });
                            }
                            this.setState(data);
                        }
                    });
                })
            }else{
                this.setState({
                    attrLoading:false,
                    visible:visible
                })
            }
        }else{
            this.setState({
                visible:visible
            })
        }
    }

    /**
     * 切换分页
     **/
    onChangePage(page, pageSize){
        this.getData(page, pageSize)
    }

    /**
     * 设置大图展示
     **/
    setImgVisible(visible,imgList,current){
        this.setState({
            imgCurrent:current,
            imgVisible:visible,
            imgList:imgList
        })
    }

    /**
     * 调整商品详情
     **/
    goDetail(item){
        let address = config.essaone[locale];
        const w = window.open('about:blank');
        w.location.href = `${address}/${item.spuId}.html?skuNo=${item.skuNo}`
    }

    componentDidMount() {
        this.getData()
    }

    render() {
        const _this = this;
        const list = this.state.list||[];
        const attrModel = this.state.attrModel||{};
        // 搜索
        const operations = <Search
            size="large"
            value={this.state.keyword}
            onChange={(e)=>{
                this.setState({
                    keyword:e.target.value
                })
            }}
            placeholder={Lang({id: 'ShouSouShangPinBianHao', default: '搜索商品编号'})}
            onSearch={value => {
                this.setState({
                    keyword:value
                },()=>{
                    this.getData(1,200);
                })
            }}
            style={{ width: 240 }}
        />;
        const currPageName =  Lang({id: "SKUPinMing",default: "商品品名"});
        return (
            <Spin spinning={this.state.loading}>
                <CommonBreadcrumb list={[{name:currPageName}]}></CommonBreadcrumb>
                <div className="sku-name-mgr__wrap" style={{marginBottom: '0'}}>
                    <div className="sku-name-mgr__tab-wrap">
                        <Tabs defaultActiveKey={this.state.type} tabBarExtraContent={operations}
                              onChange={this.tabsOnChange.bind(this)}
                              items={[
                                  {
                                      key: '0', // 待出库
                                      label:(
                                          <div
                                              className={this.state.model > 0 ? "tabName" : ""}
                                          >
                                              {Lang({id: 'DaiWanShan', default: '待完善'})}
                                              <Badge count={this.state.model} />
                                          </div> ),
                                  },{
                                      key: '1', //已出库
                                      label:(
                                          <div>
                                <span className="mr_4">
                                    {Lang({id: 'YiWanShan', default: '已完善'})}
                                </span>
                                          </div>
                                      ),
                                  }
                              ]}
                        >
                            {/*/!*待审核*!/*/}
                            {/*<TabPane*/}
                                 {/*tab={*/}
                                     {/*<div className="mr_4">*/}
                                         {/*<Badge count={this.state.model}>*/}
                                             {/*<div*/}
                                                 {/*className={this.state.model > 0 ? "tabName pr_20" : ""}*/}
                                             {/*>*/}
                                                 {/*{Lang({id: 'DaiWanShan', default: '待完善'})}*/}
                                             {/*</div>*/}
                                         {/*</Badge>*/}
                                     {/*</div>*/}
                                 {/*}*/}
                                 {/*key="0">*/}
                            {/*</TabPane>*/}
                            {/*/!*已审核*!/*/}
                            {/*<TabPane tab={(*/}
                                {/*<div>*/}
                                {/*<span className="mr_4">*/}
                                    {/*{Lang({id: 'YiWanShan', default: '已完善'})}*/}
                                {/*</span>*/}
                                {/*</div>*/}
                            {/*)}*/}
                                     {/*key="1">*/}
                            {/*</TabPane>*/}
                        </Tabs>
                    </div>
                    <div className="sku-name-mgr__main">
                        {
                            list.length==0?<Empty className="sku-name-mgr__empty-wrap"></Empty>:null
                        }
                        {
                            list.map((item,index)=>{
                                let newCarousel;
                                let operateNameList = item.operateNameList?item.operateNameList:[{lang:'ru',operateName:''}];
                                return <div key={index} className={`item ${(this.state.type=='0'&&item.isSave)?'is-save':''}`}>
                                    <div className="relative">
                                        <LazyLoad height={240} offset={100}>
                                            <Carousel autoplay={false} ref={carousel=>newCarousel=carousel}>
                                                {
                                                    (item.pictureList||[]).map((img,imgIndex)=>{
                                                        return <img onClick={this.setImgVisible.bind(this,true,item.pictureList,imgIndex)} key={imgIndex} src={img.url?img.url+'@!webp_300_q80':''} alt={img.code}/>
                                                    })
                                                }
                                            </Carousel>
                                        </LazyLoad>

                                        {
                                            (item.pictureList||[]).length>1?
                                                <div className="prev-btn" onClick={()=>{newCarousel.prev()}}><i className="ri-arrow-left-s-line color-white"></i></div>
                                                :
                                                null
                                        }
                                        {
                                            (item.pictureList||[]).length>1?
                                                <div className="next-btn" onClick={()=>{newCarousel.next()}}><i  className="ri-arrow-right-s-line color-white"></i></div>
                                                :
                                                null
                                        }
                                    </div>
                                    <div>
                                        <p className="name" onClick={this.goDetail.bind(this,item)}>{item.skuNameRu||'-'}</p>
                                        <p className="sub-name">{item.subName||'-'}</p>
                                        <p className="name-zh">{item.skuNameZh||'-'}</p>
                                        <div ref={'input'+index}>
                                            {
                                                (operateNameList||[]).map((option,optionIndex)=>{
                                                    if(option.lang=='ru'){
                                                        return <Input.TextArea maxLength={512} disabled={(this.state.type=='1'&&item.isSave)?true:false} key={optionIndex} rows={4}
                                                                               defaultValue={option.operateName}
                                                        ></Input.TextArea>
                                                    }else{
                                                        return null;
                                                    }
                                                })
                                            }
                                        </div>
                                        <div className="item-footer mt_8">
                                            <div>
                                            <span className="a-link mr_14" onClick={this.changeVisible.bind(this,true,item)}>
                                                {Lang({id: 'ShuXin', default: '属性'})}
                                            </span>
                                                {/*{
                                                    item.hasVideo?<span onClick={this.changeVisible.bind(this,false)}>
                                                            <VideoModal url={item.videoUrl}>
                                                                <span className="a-link">
                                                                    {Lang({id: 'ShiPin', default: '视频'})}
                                                                </span>
                                                            </VideoModal>
                                                        </span>
                                                        :
                                                        null
                                                }*/}
                                            </div>

                                            <div className="flex-item">
                                                {
                                                    this.state.type =='1'?
                                                        <div className="flex-item">
                                                            <div className="mr_40 align-self-center">
                                                                <span className="iconfont icon-edit-line mr_10"></span>
                                                                <span>{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span>
                                                            </div>
                                                            <div className="mr_14  align-self-center">
                                                                <span className="iconfont icon-tou mr_10"></span>
                                                                <span>{item.createUserName||'-'}</span>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }

                                                {
                                                    this.state.type=='0'?
                                                        (
                                                            item.isSave?
                                                                <Button loading={item.isSubmitLoading} onClick={this.save.bind(this,index)}>{__getServerLanguage('YiBaoCun')}</Button>
                                                                :
                                                                <Button loading={item.isSubmitLoading} type="primary" onClick={this.save.bind(this,index)}>{__getServerLanguage('BaoCun')}</Button>
                                                        ):
                                                        (
                                                            !item.isSave?
                                                                <Button loading={item.isSubmitLoading} type="primary" onClick={this.save.bind(this,index)}>{__getServerLanguage('BaoCun')}</Button>
                                                                :
                                                                <Button loading={item.isSubmitLoading} className="edit-btn" onClick={this.edit.bind(this,index)}>{__getServerLanguage('BianJi')}</Button>
                                                        )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }


                        {
                            this.state.type=='0'?
                                <div className="text-center mt_16 pb_26">
                                    {
                                        list.length==0?null:<Button size="large" onClick={this.getData.bind(this,1,200)} className="new-btn">{Lang({id: 'XinYiPi', default: '新一批'})}</Button>
                                    }
                                </div>
                                :
                                <div className="mt_16 pb_26">
                                    {
                                        list.length==0?
                                            null
                                            :
                                            <Pagination showQuickJumper
                                                        current={this.state.pageIndex}
                                                        pageSize={this.state.pageSize}
                                                        total={this.state.total}
                                                        showSizeChanger={true}
                                                        showTotal={(total) => `Total ${total} items`}
                                                        onChange={this.onChangePage.bind(this)}/>
                                    }
                                </div>
                        }

                    </div>
                    <Drawer onClose={this.changeVisible.bind(this,false)} placement='left' title={__getServerLanguage('ShangPinXinXi')} width={520} open={this.state.visible} mask={false}>
                        <Spin spinning={this.state.attrLoading} tip={__getServerLanguage('ZhengZaiChuLiQingShaoHou')}>
                            {
                                (this.state.visible&&attrModel.hasVideo)?
                                    <div className="mb_16">
                                        <video src={attrModel.videoUrl} width="472px" autoPlay="autoplay" muted="muted" height="270px"
                                               controls='controls'></video>
                                    </div>
                                    :
                                    null
                            }

                            <ul className="attr-wrap">
                                {/*主材质*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('CaiZhi')}：</span>
                                    <span>
                                        {attrModel.mainMaterials||'-'}
                                    </span>
                                </li>
                                {/*商品尺寸*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('ShangPinChiCun') + "(cm)"}：</span>
                                    <span>
                                        {attrModel.length ? toFixedWithCommas(attrModel.length, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.width ? toFixedWithCommas(attrModel.width, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.height ? toFixedWithCommas(attrModel.height, 2) : '-'}
                                    </span>
                                </li>
                                {/*外箱尺寸*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('WaiXiangChiCun2') + "(cm)"}：</span>
                                    <span>
                                        {attrModel.outBoxLength ? toFixedWithCommas(attrModel.outBoxLength, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.outBoxWidth ? toFixedWithCommas(attrModel.outBoxWidth, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.outBoxHeight ? toFixedWithCommas(attrModel.outBoxHeight, 2) : '-'}
                                    </span>
                                </li>
                                {/*包装尺寸*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('BaoZhuangChiCun') + "(cm)"}：</span>
                                    <span>
                                        {attrModel.packageLength ? toFixedWithCommas(attrModel.packageLength, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.packageWidth ? toFixedWithCommas(attrModel.packageWidth, 2) : '-'}
                                                &nbsp;×&nbsp;{attrModel.packageHeight ? toFixedWithCommas(attrModel.packageHeight, 2) : '-'}
                                    </span>
                                </li>
                                {/*外箱体积*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('WaiXiangTiJi') + '(m³)'}：</span>
                                    <span>{toFixedWithCommas(attrModel.outBoxVolume, 3) || '-'}</span>
                                </li>

                                {/*毛净重*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('MaoJingZhong') + "(Kg)"}：</span>
                                    <span>
                                        {attrModel.grossWeight ? toFixedWithCommas(attrModel.grossWeight, 3) : '-'}&nbsp;/&nbsp;{attrModel.netWeight ? attrModel.netWeight : '-'}
                                    </span>
                                </li>
                                {/*包装分类*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('BaoZhuangFenLi')}：</span>
                                    <span>
                                        {attrModel.isPackageDepart === 0 ? __getServerLanguage('Fou') : __getServerLanguage('Shi')}
                                    </span>
                                </li>
                                {/*包装语言*/}
                                <li>
                                    <span className="color-little-gray">{__getServerLanguage('BaoZhuangYuYan')}：</span>
                                    <span>
                                        {attrModel.packageLangs||'-'}
                                    </span>
                                </li>
                                {
                                    (attrModel.attributeList||[]).map((item,index)=>{
                                        return <li key={index}>
                                            <span>{item.attributeName}：</span>
                                            <span>
                                                {item.optionList.map(function (option,optionIndex) {
                                                    return <span key={optionIndex}>
                                                                {optionIndex!==0&&','}
                                                        {option.optionName||'-'}
                                                            </span>
                                                })}
                                            </span>
                                        </li>
                                    })
                                }
                            </ul>
                        </Spin>
                    </Drawer>
                    {/*放大图*/}
                    {
                        this.state.imgVisible?
                            <Image.PreviewGroup
                                preview={{
                                    current:this.state.imgCurrent,
                                    visible:this.state.imgVisible,
                                    onVisibleChange:(visible, prevVisible, current)=>{
                                        _this.setState({
                                            imgVisible:visible
                                        })
                                    }
                                }}
                            >
                                {this.state.imgList.map((item,index)=>{
                                    return <Image key={index} style={{ display: 'none' }} src={item.url} />
                                })}
                            </Image.PreviewGroup>
                            :
                            null
                    }
                </div>
            </Spin>
        )
    }
}

export default SkuNameMgr
